import { DueDiligenceRecordsListSortBy } from '@/__generated__/graphql';
import { createSimpleSelectOption } from '../basicComponents/select/utils';

export const dealRegistryTableColumns = [
  {
    title: 'Deal',
    key: DueDiligenceRecordsListSortBy.InvestmentName,
    width: 400,
    keySort: 'Deal',
    cellKey: 'name',
    isHidden: false,
    order: 0,
    isFixed: true
  },
  {
    title: 'Date Added',
    key: DueDiligenceRecordsListSortBy.CreatedDate,
    width: 300,
    keySort: 'Date Added',
    cellKey: 'createdAt',
    isHidden: false,
    order: 1
  },
  {
    title: 'Asset Class',
    key: DueDiligenceRecordsListSortBy.AssetClass,
    width: 360,
    keySort: 'Asset Class',
    cellKey: 'assetClass',
    isHidden: false,
    order: 2
  },
  { title: 'Strategy', key: null, width: 325, keySort: 'strategy', cellKey: 'strategy', isHidden: false, order: 3 },
  { title: 'Tags', key: null, width: 300, keySort: 'tags', cellKey: 'tags', isHidden: false, order: 4 },
  {
    title: 'Target IRR',
    key: DueDiligenceRecordsListSortBy.TargetIrr,
    width: 200,
    keySort: 'Target IRR',
    cellKey: 'targetIRR',
    isHidden: false,
    order: 5
  },
  {
    title: 'Target Yield',
    key: DueDiligenceRecordsListSortBy.TargetYield,
    width: 200,
    keySort: 'Target Yield',
    cellKey: 'targetYield',
    isHidden: false,
    order: 6
  },
  { title: 'Status', key: DueDiligenceRecordsListSortBy.Status, width: 300, keySort: 'Status', cellKey: 'status', isHidden: false, order: 7 },
  { title: 'Tier', key: DueDiligenceRecordsListSortBy.Tier, width: 300, keySort: 'Tier', cellKey: 'tier', isHidden: false, order: 8 },
  { title: 'AI Suggestions', key: null, width: 250, keySort: 'ai_suggestions', cellKey: 'ai_suggestions', isHidden: false, order: 9 }
];

export const dealRegistryStatusFilterSelectOptions = [
  'All Statuses',
  'Lead',
  'Declined',
  'Due Diligence',
  'Approved',
  'Rejected',
  'Open',
  'Active',
  'Realized',
  'Redeemed'
].map((status) => createSimpleSelectOption(status));

export const dealRegistrySort = [
  {
    title: 'Deal • A -> Z',
    key: DueDiligenceRecordsListSortBy.InvestmentName,
    asc: true
  },
  {
    title: 'Deal • Z -> A',
    key: DueDiligenceRecordsListSortBy.InvestmentName,
    asc: false
  },
  {
    title: 'Date Added • Newest -> Oldest',
    key: DueDiligenceRecordsListSortBy.CreatedDate,
    asc: false
  },
  {
    title: 'Date Added • Oldest -> Newest',
    key: DueDiligenceRecordsListSortBy.CreatedDate,
    asc: true
  },
  {
    title: 'Asset Class • A -> Z',
    key: DueDiligenceRecordsListSortBy.AssetClass,
    asc: true
  },
  {
    title: 'Asset Class • Z -> A',
    key: DueDiligenceRecordsListSortBy.AssetClass,
    asc: false
  },
  {
    title: 'Target IRR • Max -> Min',
    key: DueDiligenceRecordsListSortBy.TargetIrr,
    asc: false
  },
  {
    title: 'Target IRR • Min -> Max',
    key: DueDiligenceRecordsListSortBy.TargetIrr,
    asc: true
  },
  {
    title: 'Target Yield • Max -> Min',
    key: DueDiligenceRecordsListSortBy.TargetYield,
    asc: false
  },
  {
    title: 'Target Yield • Min -> Max',
    key: DueDiligenceRecordsListSortBy.TargetYield,
    asc: true
  },
  {
    title: 'Status • First -> Last',
    key: DueDiligenceRecordsListSortBy.Status,
    asc: true
  },
  {
    title: 'Status • Last -> First',
    key: DueDiligenceRecordsListSortBy.Status,
    asc: false
  },
  {
    title: 'Tier • A -> Z',
    key: DueDiligenceRecordsListSortBy.Tier,
    asc: false
  },
  {
    title: 'Tier • Z -> A',
    key: DueDiligenceRecordsListSortBy.Tier,
    asc: true
  }
];
